import { PlusOutlined } from "@ant-design/icons";
import { Button, Form, Row, Space, Spin, Table } from "antd";
import { useEffect, useRef, useState } from "react";

import courseApi from "../../../api/course";
import { columnsTableComboCourse, dataComboCourse } from "../config";
import ListActionButton from "../../../components/ListActionButton/ActionListButton";
import ModalCustom from "../../../components/ModalCustom/ModalCustom";
import InputFields from "../../../components/InputFields/InputFields";
import Notification from "../../../components/Notification";

const ComboCourse = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
  });
  const [total, setTotal] = useState();
  const addComboCourse = useRef();
  const [formAddComboCourse] = Form.useForm();
  const [textModalComboCourse, setTextModalComboCourse] = useState({
    text: "Thêm mới",
    status: 0,
  });
  const [dataSource, setDataSource] = useState(dataComboCourse);
  const values = Form.useWatch([], formAddComboCourse);

  const [idComboCourse, setIdComboCourse] = useState(null);
  const [tempOption, setTempOptions] = useState(null);

  const onChangePagination = (page, limit) => {
    setParams({ ...params, page: page, limit: limit });
  };

  const getListComboCourse = async () => {
    try {
      const res = await courseApi.getListCombo(params);
      setData(res.data);
      Notification("success", "Lấy danh sách mẫu hợp đồng thành công");
    } catch (error) {
      Notification("error", "Lấy danh sách mẫu hợp đồng không thành công");
    }
  };

  const handleAddComboCourse = async () => {
    setTextModalComboCourse({
      status: 0,
      text: "Thêm mới",
    });
    try {
      const data = await formAddComboCourse.validateFields();
      const newData = Object.fromEntries(
        Object.entries(data).filter(([key]) => key !== "price")
      );
      const outputData = transformComboData(newData);
      await courseApi.addCombo(outputData);
      addComboCourse.current.closeModal();
      Notification("success", "Tạo mới thành công");
      formAddComboCourse.resetFields();
      getListComboCourse();
    } catch (error) {
      Notification("error", "Tạo mới không thành công");
    }
  };

  // chuyển đổi dữ liệu đầu ra
  function transformComboData(data) {
    return {
      ...data,
      items: (data.items || []).map((id) => ({
        courseId: id,
        courseCode: "",
        courseName: "",
        courseGroup: "",
        listPrice: 0,
      })),
    };
  }

  const handleEditComboCourse = async () => {
    try {
      console.log(idComboCourse);

      const data = await formAddComboCourse.validateFields();
      const newData = Object.fromEntries(
        Object.entries(data).filter(([key]) => key !== "price")
      );
      console.log("🚀 ~ handleEditComboCourse ~ newData:", newData);
      // const outputData = transformComboData(newData);

      await courseApi.updateCombo({
        ...newData,
        id: idComboCourse,
      });
      addComboCourse.current.closeModal();
      getListComboCourse();
      Notification("success", "Cập nhật thành công");
      formAddComboCourse.resetFields();
      setIdComboCourse(null);
    } catch (error) {
      Notification("error", "Cập nhật không thành công");
    }
  };

  const handleDeleteComboCourse = async (id) => {
    try {
      await courseApi.deleteCombo(id);
      Notification("success", "Xoá thành công");
      formAddComboCourse.resetFields();
      setIdComboCourse(null);
      getListComboCourse();
    } catch (error) {
      Notification("error", "Xoá không thành công");
    }
  };

  const getListOnceCourse = async () => {
    try {
      const res = await courseApi.getListCourse(params);
      const options = Array.isArray(res.data)
        ? res.data.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        : [];
      const newDataSource = dataSource.map((field) =>
        field.name === "items" ? { ...field, options: options } : field
      );
      setTempOptions(res.data);
      setDataSource(newDataSource);
      Notification("success", "Lấy danh sách mẫu hợp đồng thành công");
    } catch (error) {
      Notification("error", "Lấy danh sách mẫu hợp đồng không thành công");
    }
  };

  columnsTableComboCourse.map((e) => {
    if (e.key == "action") {
      e.render = (_, record, index) => {
        return (
          <ListActionButton
            deleteFunction={() => {
              handleDeleteComboCourse(record.id);
            }}
            editFunction={() => {
              formAddComboCourse.setFieldsValue(record);
              if (record.items) {
                const itemIds = record.items.map((item) => item.courseId);
                formAddComboCourse.setFieldValue("items", itemIds);
              }
              addComboCourse.current.openModal();
              setIdComboCourse(record.id);
              setTextModalComboCourse({
                status: 1,
                text: "Chỉnh sửa",
              });
            }}
          />
        );
      };
    }
  });

  useEffect(() => {
    getListOnceCourse();
  }, []);

  //
  useEffect(() => {
    getListComboCourse();
  }, [params]);
  useEffect(() => {
    const totalId = formAddComboCourse.getFieldValue("items");
    if (tempOption) {
      const selectedCourses = tempOption?.filter((c) =>
        totalId?.includes(c.id)
      );
      const total = selectedCourses.reduce((sum, c) => sum + c.listPrice, 0);
      formAddComboCourse.setFieldValue("price", total);
    }
  }, [values]);
  return (
    <Spin spinning={loading}>
      <div className="container">
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Row justify="space-between">
            <div className="title">Danh sách combo khóa học</div>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                addComboCourse.current.openModal();
                formAddComboCourse.resetFields();
                setTextModalComboCourse({
                  status: 0,
                  text: "Tạo mới",
                });
              }}
            >
              Tạo mới
            </Button>
          </Row>
          <Table
            columns={columnsTableComboCourse}
            dataSource={data}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              total: total,
              limit: params.limit,
              current: params.page,
              onChange: onChangePagination,
            }}
            bordered
          />
          <ModalCustom
            ref={addComboCourse}
            title={`${textModalComboCourse.text}`.toLocaleUpperCase()}
          >
            <Space
              direction="vertical"
              size={"large"}
              style={{
                width: "100%",
              }}
            >
              <Form form={formAddComboCourse}>
                <Row gutter={[16, 8]}>
                  <InputFields data={dataSource} />
                </Row>
              </Form>
              <Row justify={"end"}>
                <Space đirection="horizontal" size="small">
                  <Button
                    type="primary"
                    onClick={
                      textModalComboCourse.status === 0
                        ? handleAddComboCourse
                        : handleEditComboCourse
                    }
                  >
                    {`${textModalComboCourse.text}`}
                  </Button>
                  <Button
                    danger
                    onClick={() => addComboCourse.current.closeModal()}
                  >
                    Hủy
                  </Button>
                </Space>
              </Row>
            </Space>
          </ModalCustom>
        </Space>
      </div>
    </Spin>
  );
};
export default ComboCourse;
